import * as React from 'react';
import { useEffect } from 'react';

import { translate } from '~l10n/client';
import { toast } from '~shared/components/Toast';

import { InsightsNone } from './InsightsNone';

interface InsightsFailedProps {
  activityInstanceId: number;
  averageScoreRate?: number | null;
}

export function InsightsFailed({
  activityInstanceId,
  averageScoreRate,
}: InsightsFailedProps) {
  useEffect(() => {
    toast.critical(translate('Unexpected Error'));
  }, []);

  return (
    <InsightsNone
      activityInstanceId={activityInstanceId}
      averageScoreRate={averageScoreRate}
    />
  );
}
